module.exports = __webpack_public_path__ + "img/Stab_Stv_OB.8424e0eb.svg";